import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1576091160550-2173dba999ef)` }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.faq.title}
          </h2>
          <p className="text-lg text-gray-600">
            {t.faq.subtitle}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {t.faq.items.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border rounded-lg px-6 shadow-sm hover:shadow-md transition-shadow bg-white"
            >
              <AccordionTrigger className="text-left font-semibold" style={{ color: '#2D4A8F' }}>
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;